<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="hero-section-container">
        <div class="section hero-section" id="hero">
          <div class="wrapper">
            <div class="title big">
              {{ $t("IdeasGen - The Best Place To Buy AI Prompt Bundles") }}
            </div>
            <div class="desc regular">
              {{ $t("A prompts for all your creative needs in one place") }}
            </div>
            <button class="button button-main" @click="$parent.openSignUpModal">
              <span>{{ $t(`Join now`) }}</span>
              <img src="./../img/link.svg" class="img" />
            </button>
            <div class="search-block">
              <div class="title small">
                <div class="icon">
                  <img src="./../img/search.svg" class="img" />
                </div>
                <span>{{ $t("Serach prompts") }}</span>
              </div>
              <div class="desc semibold">
                {{ $t("A prompts for all your creative needs in one place") }}
              </div>
              <div class="form">
                <div class="select-container">
                  <Select2
                    class="select2 single"
                    v-model="activeCategory"
                    :options="categoryOptions"
                    :placeholder="$t('Topic')"
                    @select="onSelectCategory($event)"
                  />
                </div>
                <!-- <div class="select-container">
                  <Select2
                    class="select2 single"
                    v-model="activeCategory2"
                    :options="categoryOptions2"
                    :placeholder="$t('Categories')"
                    @select="onSelectCategory($event)"
                  />
                </div> -->
                <div
                  class="select-container"
                >
                  <Select2
                    class="select2 single"
                    v-model="activeModel"
                    :options="modelOptions"
                    :placeholder="$t('Model')"
                    @select="onSelectModel($event)"
                  />
                </div>
                <button class="button" @click="getProducts">
                  {{ $t(`Search`) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section arrivals-section">
        <div class="top">
          <div class="title">{{ $t(`Trending prompts`) }}</div>
          <router-link to="/product-list" class="button button-main">
            <span>{{ $t(`See all`) }}</span>
            <img src="./../img/link.svg" class="img" />
          </router-link>
        </div>
        <div class="wrapper">
          <SlickItem
            v-if="$parent.tranding && $parent.tranding.length"
            :isPack="false"
            :list="$parent.tranding"
            :tag="'Stable Diffusion'"
            @goToProduct="goToProduct"
            :isAuth="isAuth"
            :currency="currency"
            @openReadyModal="openReadyModal"
            @openSignInModal="$parent.openSignInModal"
          />
        </div>
      </div>

      <div class="how-it-works" id="howItWorks">
        <div class="section">
          <div class="wrapper">
            <div class="left">
              <div class="title">{{ $t(`How it works?`) }}</div>
              <img src="./../img/howItWorks.png" class="left-img img" />
            </div>
            <div class="right">
              <div class="accordion">
                <div
                  class="accordion-item"
                  :class="{ active: activeIndex === index }"
                  v-for="(item, index) in items"
                  :key="index"
                  @click="toggle(index)"
                >
                  <div class="accordion-header">
                    <h3 class="title regular">{{ item.title }}</h3>
                  </div>
                  <div class="accordion-content" v-show="activeIndex === index">
                    <p class="desc">{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section features-section" id="features">
        <div class="wrapper">
          <div class="title">{{ $t(`Features`) }}</div>
          <div class="list flex">
            <div class="item">
              <div class="desc small semibold">01</div>
              <div class="icon">
                <img src="./../img/features/1.svg" class="img" />
              </div>
              <div class="title extrasmall">{{ $t(`Save time and effort`) }}</div> 
              <div class="desc">
                {{ $t('IdeasGen makes it easy to find high-quality AI prompts for all your creative needs') }}
              </div>
            </div>
            <div class="item">
              <div class="desc small semibold">02</div>
              <div class="icon">
                <img src="./../img/features/2.svg" class="img" />
              </div>
              <div class="title extrasmall">{{ $t(`Tailored for Every Need`) }}</div> 
              <div class="desc">
                {{ $t('From business automation to creative writing, find prompts that fit your goals') }}
              </div>
            </div>
            <div class="item">
              <div class="desc small semibold">03</div>
              <div class="icon">
                <img src="./../img/features/3.svg" class="img" />
              </div>
              <div class="title extrasmall">{{ $t(`Buy once use forever`) }}</div> 
              <div class="desc">
                {{ $t('Get lifetime access to high-quality prompts with a single purchase') }}
              </div>
            </div>
            <div class="item">
              <div class="desc small semibold">04</div>
              <div class="icon">
                <img src="./../img/features/4.svg" class="img" />
              </div>
              <div class="title extrasmall">{{ $t(`Improve your AI skills`) }}</div> 
              <div class="desc">
                {{ $t('Master AI interactions with expertly crafted prompts that enhance your results') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="section pack-section">
        <div class="wrapper">
          <div class="title medium">
            {{
              $t(`Choose the prompts that resonate with you and take your creativity to new
            heights.`)
            }}
          </div>
          <SlickItem
            v-if="$parent.packs && $parent.packs.length"
            @openSignInModal="$parent.openSignInModal"
            :isAuth="isAuth"
            :activePack="$parent.activePack"
            @openReadyModal="openReadyModal"
            :list="$parent.packs"
            :tag="$parent.activePack.title"
            @goToProduct="goToProduct"
            :currency="currency"
            :isPack="true"
          />
        </div>
      </div> -->
      <div id="cases">
        <RandomCasesSlider />
      </div>
      <div class="section we-believe-section" id="weBelieve">
        <div class="wrapper">
          <div class="title">{{ $t(`We believe!`) }}</div>
          <div class="flex we-believe">
            <div class="left">
              <div class="card">
                <div class="title title-36">
                  {{ $t(`At IdeasGen we believe in the power of human creativity and the potential of artificial intelligence to unlock new realms of imagination. We're driven by a single goal -`) }}
                  <span class="pink">{{ $t('to bridge the gap between human ingenuity and AI capabilities') }}</span>
                </div>
              </div>
            </div>
            <div class="right flex">
              <div class="card">
                <div class="title title-40 semibold">
                  {{ $t('98%') }}
                </div>
                <div class="title extrasmall">
                  {{ $t('of Users Boost Productivity') }}
                </div>
              </div>
              <div class="card">
                <div class="title title-40 semibold">
                  <span class="pink">{{ $t('80%') }}</span>
                </div>
                <div class="title extrasmall">
                  {{ $t('of Customers Return for More') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import Select2 from "vue3-select2-component";
import SlickItem from "../components/SlickItem.vue";
import RandomCasesSlider from "../components/RandomCasesSlider.vue";
import { mapGetters } from "vuex";

export default {
  name: "Home",
  props: ["currency"],
  components: {
    SlickItem,
    RandomCasesSlider,
    Select2,
  },
  data: function () {
    return {
      imgDomain: "",
      modelOptions: [],
      categoryOptions: [],
      categoryOptions2: [],
      activeModel: "",
      activeCategory: "",
      activeCategory2: "",
      activeIndex: 0,
      items: [
        {
          title: "Browse prompts",
          content:
            "Browse prompts filtered by topic, price and model. You can also use keywords to search for specific prompts.",
        },
        {
          title: "Read description",
          content:
            "Review the prompt details carefully to make sure it fits your needs.",
        },
        // {
        //   title: "Click “Buy” button",
        //   content:
        //     "Learn how to select prompts by clicking the buy button to add them to your cart.",
        // },
        {
          title: "Complete purchase",
          content: "Learn how to select prompts by clicking the buy button to finalize your purchase.",
        },
      ],
    };
  },
  watch: {
    currency: function () {
      this.$parent.getPacks();
      this.$parent.getTranding();
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getModels();
    this.getCategories();
    this.getCategories2();
  },
  methods: {
    toggle(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    getProducts() {
      this.$router.push({ path: "/product-list" });
    },
    onSelectCategory(event) {
      this.activeCategory = event.id;
      this.$emit("setCategory", event.id);
    },
    onSelectCategory2(event) {
      this.activeCategory2 = event.id;
      this.$emit("setCategory2", event.id);
    },
    onSelectModel(event) {
      this.activeModel = event.id;
      this.$emit("setModel", event.id);
    },
    getCategories2() {
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          const newCategories = res.data.payload.filter(
            (item) => item.parent_id !== null
          );
          this.categoryOptions2 = newCategories.map(
            ({ id: id, title: text, url: url }) => ({
              id,
              text,
              url,
            })
          );
          const filteredArray = this.removeIdenticalObjects(
            this.categoryOptions2
          );
          this.categoryOptions2 = filteredArray;

          this.categoryOptions2.unshift({ id: 0, text: "All", url: "" });
        })
        .catch(() => {});
    },
    getCategories() {
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          const newCategories = res.data.payload.filter(
            (item) => item.parent_id !== null
          );
          this.categoryOptions = newCategories.map(
            ({ id: id, title: text, url: url }) => ({
              id,
              text,
              url,
            })
          );
          const filteredArray = this.removeIdenticalObjects(
            this.categoryOptions
          );
          this.categoryOptions = filteredArray;

          this.categoryOptions.unshift({ id: 0, text: "All", url: "" });
        })
        .catch(() => {});
    },
    getModels() {
      this.$http
        .get(process.env.VUE_APP_API + "categories")
        .then((res) => {
          const newCategories = res.data.payload.filter(
            (item) => item.parent_id === null
          );
          // newCategories.unshift({name: 'All'});
          this.modelOptions = newCategories.map(
            ({ id: id, title: text, url: url }) => ({
              id,
              text,
              url,
            })
          );
          this.modelOptions.unshift({ id: 0, text: "All", url: "" });
        })
        .catch(() => {});
    },
    goToProduct(item) {
      this.$emit("goToProduct", item);
    },
    setChatGptModel() {
      let model = this.$parent.models.find((obj) => obj.id === 8);
      this.$emit("setActiveModel", model);
    },
    setDalle2Model() {
      let model = this.$parent.models.find((obj) => obj.id === 9);
      this.$emit("setActiveModel", model);
    },
    setStableDiffusionModel() {
      let model = this.$parent.models.find((obj) => obj.id === 10);
      this.$emit("setActiveModel", model);
    },
    openReadyModal(item, product) {
      this.$emit("openReadyModal", item, product);
    },
  },
  computed: {
    ...mapGetters("user", ["isAuth"]),
  },
};
</script>
